define('lq/nestingContext',[

], function () {
    'use strict';

    var NestingContext = function (piping) {
        this.nestedDataSources = [];
        this.piping = piping;
    };

    NestingContext.prototype.addDataSource = function (dataSource) {
        if (this.nestedDataSources.indexOf(dataSource) !== -1)
            return;
        this.nestedDataSources.push(dataSource);
    };

    NestingContext.prototype.executeDataSources = function () {
        var self = this;
        _.forEach(this.nestedDataSources, function (dataSource) {
            var listeners = self.piping.datasources.getDatasourceListenersThatListenFor(dataSource);

            if (listeners.length) {
                self.piping.queryDispatcher.dispatch(
                    dataSource,
                    function (response) {
                        _.each(listeners, function (listener) {
                            listener.handler(response);
                        });
                    },
                    $.noop);
            }
        });
    };

    return NestingContext;
});
